import * as React from "react";
import type { SVGProps } from "react";
const SvgCircularUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 5.328v5.336M6 7.329l2-2 2 2"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.952 1.992a6.002 6.002 0 0 1 0 12.005M5.901 13.632a6 6 0 0 1-1.806-1.038M4.095 3.398c.537-.45 1.148-.8 1.806-1.039M2.046 6.952c.12-.69.361-1.353.711-1.96M2.046 9.04c.12.69.361 1.353.711 1.96"
    />
  </svg>
);
export default SvgCircularUpload;
